import {
  AkeneoModel,
  CreateAkeneoModelPayloadSchema,
  CreateAkeneoModelPaylod,
  UpdateAkeneoModelPayloadSchema,
  UpdateAkeneoModelPaylod,
} from "./models/akeneoModels.models";
import axiosInstance from "./axios";
import { validateWithSchema } from "./zodUtils";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchAkeneoModels = async (
  bearerToken,
  companyId?: number
): Promise<AkeneoModel[]> => {
  try {
    const url = companyId
      ? `${apiUrl}/Products/${companyId}/models`
      : `${apiUrl}/Products/models`;
    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch akeneo models:", error);
    throw error;
  }
};

export const fetchSingleModelWithIdentifier = async (
  bearerToken: string,
  companyId: number,
  identifier: string
): Promise<AkeneoModel> => {
  try {
    const url = `${apiUrl}/Products/${companyId}/models/${identifier}`;

    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch akeneo model:", error);
    throw error;
  }
};

export const fetchModelsWithIdentifiers = async (
  bearerToken: string,
  companyId?: number,
  identifiers?: string[]
): Promise<AkeneoModel[]> => {
  try {
    if (!identifiers || identifiers.length === 0) {
      return [];
    }
    const identifiersParam = identifiers.join(",");
    const url = `${apiUrl}/Products/${companyId}/models?identifiers=${identifiersParam}`;

    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch akeneo models with identifiers:", error);
    throw error;
  }
};

export const createAkeneoModel = async (
  bearerToken: string,
  payload: CreateAkeneoModelPaylod
): Promise<AkeneoModel> => {
  try {
    const validatedPayload = validateWithSchema(
      CreateAkeneoModelPayloadSchema,
      payload
    );

    const url = validatedPayload.companyId
      ? `${apiUrl}/Products/${validatedPayload.companyId}/models`
      : `${apiUrl}/Products/models`;
    const response = await axiosInstance.post(url, validatedPayload, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to create akeneo model:", error);
    throw error;
  }
};

export const updateAkeneoModel = async (
  bearerToken: string,
  payload: UpdateAkeneoModelPaylod
): Promise<AkeneoModel> => {
  try {
    const validatedPayload = validateWithSchema(
      UpdateAkeneoModelPayloadSchema,
      payload
    );

    const url = validatedPayload.companyId
      ? `${apiUrl}/Products/${validatedPayload.companyId}/models`
      : `${apiUrl}/Products/models`;
    const response = await axiosInstance.patch(url, validatedPayload, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to update akeneo model:", error);
    throw error;
  }
};

export const addChildrenToModelQuery = async (
  bearerToken: string,
  companyId: number,
  modelIdentifier: string,
  childAssociations: { [key: string]: number }
): Promise<AkeneoModel> => {
  try {
    const url = `${apiUrl}/Products/${companyId}/models/${modelIdentifier}/addchildren`;
    const response = await axiosInstance.patch(url, childAssociations, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to add children to akeneo model:", error);
    throw error;
  }
};
